import React, { useEffect } from 'react'
import { Grid } from "@mui/material"
import UserConfigSection from "Pages/Admin/Users/CreateDrawer/Content/Config"
import UserSitesOfficesContent from "Pages/Admin/Users/CreateDrawer/Content/SitesOffices"
import UserInfoSection from "Pages/Admin/Users/CreateDrawer/Content/UserInfo"
import ConfirmSaveModal from "Pages/Admin/Users/CreateDrawer/Content/ConfirmSaveModal"
import { useCreateUsersModal } from "Pages/Admin/Users/@hooks"
import { editUserId } from "Pages/Admin/Users/@signals"

export default function CreateUserDrawerContent() {
	const { onEditUser, userId, isEditLoading } = useCreateUsersModal()


	useEffect(() => {
		if (editUserId.value) {
			onEditUser()
		}
	}, [userId])


	return <Grid container spacing={2}>
		<Grid item xs={12}>
			<UserInfoSection isLoading={isEditLoading}/>
		</Grid>
		<Grid item xs={12}>
			<UserSitesOfficesContent isLoading={isEditLoading}/>
		</Grid>
		<Grid item xs={12}>
			<UserConfigSection isLoading={isEditLoading}/>
		</Grid>
		<ConfirmSaveModal/>
	</Grid>
}